import KPICard from './KPICard';
import MainCard from './MainCard';
import BarChart from './BarChart';
import AreaChart from './AreaChart';
import PieChart from './PieChart';
import EventsTable from './EventsTable';
import TasksTable from './TasksTable';
import StackedBarChart from './StackedBarChart';
import TimeChart from './TimeChart';
import ColumnsWithMarkersChart from './ColumnsWithMarkersChart';
import GroupedStackedColumns from './GroupedStackedColumns';
import ColumnsWithNegativeChart from './ColumnsWithNegativeChart';

const Charts = {
  KPICard,
  MainCard,
  BarChart,
  AreaChart,
  PieChart,
  EventsTable,
  TasksTable,
  StackedBarChart,
  TimeChart,
  ColumnsWithMarkersChart,
  GroupedStackedColumns,
  ColumnsWithNegativeChart,
};

export {
  KPICard,
  MainCard,
  BarChart,
  AreaChart,
  PieChart,
  EventsTable,
  TasksTable,
  StackedBarChart,
  TimeChart,
  ColumnsWithMarkersChart,
  GroupedStackedColumns,
  ColumnsWithNegativeChart,
};

export default Charts;
